import { render, staticRenderFns } from "./PhChatsCircle.vue?vue&type=template&id=a4267294"
import script from "./PhChatsCircle.vue?vue&type=script&lang=js"
export * from "./PhChatsCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports